import Vue from 'vue';
import store from '@/store';
import UrlBrowser from '../../helpers/UrlBrowser';

export default class PrefetchCity {
  constructor() {
    this.$store = store;
    this.locationFrom = null;
    this.locationTo = null;
    this.api = Vue.api;
    this.searchMode = null;
    this.locationFrom = null;
    this.countryCodeFrom = null;
    this.locationTo = null;
    this.countryCodeTo = null;
    this.prefetchMod = null;
  }

  async init() {
    const { prefetchCity } = window;
    let promisePrefetch = null;

    if (prefetchCity) {
      this.prefetchMod = 'prefetchPage';
      this.searchMode = prefetchCity.searchMode;
      this.locationFrom = prefetchCity.locationFrom;
      this.countryCodeFrom = prefetchCity.countryCodeFrom || 'RU';
      this.locationTo = prefetchCity.locationTo;
      this.countryCodeTo = prefetchCity.countryCodeTo || 'RU';
      promisePrefetch = await this.initPrefetchCity();
    } else {
      const urlBrowser = new UrlBrowser();
      const urlPrefetchCity = urlBrowser.getParamURLBrowser('url_prefetch_city');
      if (urlPrefetchCity === 'enable') {
        this.prefetchMod = 'prefetchUrl';
        this.searchMode = urlBrowser.getParamURLBrowser('search_mode');
        this.locationFrom = urlBrowser.getParamURLBrowser('lf');
        this.countryCodeFrom = urlBrowser.getParamURLBrowser('ccf');
        this.locationTo = urlBrowser.getParamURLBrowser('lt');
        this.countryCodeTo = urlBrowser.getParamURLBrowser('cct');
        promisePrefetch = await this.initPrefetchCity();
      }
    }

    return promisePrefetch;
  }

  async initPrefetchCity() {
    return new Promise((resolve, reject) => {
      const promiseLocationFrom = this.setLocation({
        countryCode: this.countryCodeFrom,
        searchString: this.locationFrom,
      }, 'from');
      const promiseLocationTo = this.setLocation({
        countryCode: this.countryCodeTo,
        searchString: this.locationTo,
      }, 'to');

      Promise.all([promiseLocationFrom, promiseLocationTo])
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


  async setLocation(location, direction) {
    if (!location) {
      return;
    }

    const { countryCode, searchString } = location;
    if (!searchString) {
      return;
    }
    const autoCompleteRequest = {
      countryCode,
      searchString,
      requestedEntity: this.searchMode,
    };

    const autocomplete = await this.api.autocomplete(autoCompleteRequest);
    const [firstSearchLocation] = autocomplete;

    if (direction === 'from') {
      this.$store.dispatch('preparation/setLocationFrom', firstSearchLocation);
    } else {
      this.$store.dispatch('preparation/setLocationTo', firstSearchLocation);
    }
  }
}
